module.exports = __webpack_public_path__ + "img/defaultVoucherIco.5726b966.png";